// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading___1FDn8","inverted":"inverted___1DQ8r","regular":"regular___2Tid9"};